import api from './api';

const projectDocumentService = {
  getAll: async (params = {}) => {
    const response = await api.get('/project-documents', { params });
    return response.data;
  },
  getStats: async () => {
    const response = await api.get('/project-documents/stats');
    return response.data;
  },
  getById: async (id) => {
    const response = await api.get(`/project-documents/${id}`);
    return response.data;
  },
  create: async (data) => {
    const response = await api.post('/project-documents', data);
    return response.data;
  },
  update: async (id, data) => {
    const response = await api.put(`/project-documents/${id}`, data);
    return response.data;
  },
  remove: async (id) => {
    const response = await api.delete(`/project-documents/${id}`);
    return response.data;
  }
};

export default projectDocumentService;
